import { render, staticRenderFns } from "./child-program.vue?vue&type=template&id=35c72924&scoped=true"
import script from "./child-program.vue?vue&type=script&lang=js"
export * from "./child-program.vue?vue&type=script&lang=js"
import style0 from "./child-program.vue?vue&type=style&index=0&id=35c72924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c72924",
  null
  
)

export default component.exports